import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component export class ManualSwitcherTrigger extends ThemeComponent {
    @Ref() manualSwitcherTrigger!: HTMLButtonElement;

    init() {
        this.$log.debug(this.$name, 'Initing');

        this.$listen(this.manualSwitcherTrigger, 'click', () => this.toggleSwitcher());
    }

    toggleSwitcher() {
        document.dispatchEvent(new Event('toggleSwitcher'));
    }
}
